import { useContext } from 'react';

import { Tooltip, TooltipPopper, TriggerText } from '@zillow/constellation';
import { Paragraph, Text } from '@zillow/constellation-10';

import { RoutingSelectors } from '../../../../selectors';
import { useSelector } from '../../../../selectors/useSelector';

import propertyUtils from '../../../../utils/propertyUtils';
import { useGetPremiumOverview } from '../../../../hooks/queries/freemium';

import { FreemiumContext } from '../../context';

import type { InlineMediaQueryProp } from '@zillow/constellation';

type ActiveCompsTooltipProps = {
  triggerText: string;
  fontType?: typeof InlineMediaQueryProp;
  fontColor?: string;
};

const ActiveCompsTooltip = ({
  triggerText,
  fontType = { base: 'body-sm' },
  fontColor = 'text.subtle',
}: ActiveCompsTooltipProps) => {
  const {
    freemiumState: {
      filters: { beds, filterType, propertyType },
    },
  } = useContext(FreemiumContext);

  const listingId = useSelector((state) => RoutingSelectors.makeListingId(state));

  const { data: overviewData } = useGetPremiumOverview({ listingId });

  if (!overviewData) {
    return null;
  }

  const { formattedCityState } = propertyUtils.formatAddress(overviewData);
  const searchArea = filterType === 'zip' ? overviewData.zip : formattedCityState;
  const searchString = propertyUtils.formatSearchString(beds, propertyType, searchArea, false);

  return (
    <TooltipPopper
      placement="top"
      triggered={<Tooltip body={<Paragraph>{`Matching your filters for ${searchString}`}</Paragraph>} />}
    >
      <TriggerText>
        <Text css={{ textStyle: fontType, color: fontColor }}>{triggerText}</Text>
      </TriggerText>
    </TooltipPopper>
  );
};

export default ActiveCompsTooltip;
